import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const alarms = [
  { id: "AL001", level: "danger", msg: "R002 李秀梅 - 燃气泄漏报警", time: "09:23", location: "朝阳区望京" },
  { id: "AL002", level: "danger", msg: "C001 老北京涮肉馆 - 压力异常超限", time: "08:45", location: "西城区西单" },
  { id: "AL003", level: "warning", msg: "R001 张建国 - 余额不足预警", time: "08:30", location: "海淀区中关村" },
  { id: "AL004", level: "warning", msg: "R015 周明 - 设备离线超24小时", time: "07:15", location: "丰台区方庄" },
  { id: "AL005", level: "info", msg: "C003 金鼎轩餐厅 - 用气量异常偏高", time: "06:50", location: "朝阳区亮马桥" },
  { id: "AL006", level: "warning", msg: "R028 赵丽华 - 安检逾期未完成", time: "06:00", location: "石景山区古城" },
  { id: "AL007", level: "danger", msg: "R045 刘建国 - 阀门异常关闭", time: "05:30", location: "东城区东直门" },
  { id: "AL008", level: "info", msg: "BD003 王大明 - 银行代扣失败", time: "05:00", location: "丰台区南三环" },
];

export default function AlarmScroll() {
  const navigate = useNavigate();
  const [activeIdx, setActiveIdx] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setActiveIdx(prev => (prev + 1) % alarms.length);
    }, 2500);
    return () => clearInterval(timer);
  }, []);

  const levelConfig = {
    danger: { color: "text-red-500", bg: "bg-red-50", dot: "bg-red-500", label: "紧急" },
    warning: { color: "text-amber-500", bg: "bg-amber-50", dot: "bg-amber-500", label: "警告" },
    info: { color: "text-blue-500", bg: "bg-blue-50", dot: "bg-blue-400", label: "提示" },
  };

  return (
    <div className="bg-white rounded-xl border border-gray-100 overflow-hidden">
      <div className="flex items-center justify-between px-4 py-3 border-b border-gray-100">
        <div className="flex items-center gap-2">
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-alarm-warning-line text-red-500 text-sm"></i>
          </div>
          <span className="text-sm font-semibold text-gray-800">实时告警</span>
          <span className="inline-flex items-center gap-1 bg-red-50 text-red-500 text-[10px] px-1.5 py-0.5 rounded-full">
            <span className="w-1.5 h-1.5 rounded-full bg-red-500 animate-pulse inline-block"></span>
            {alarms.filter(a => a.level === "danger").length} 紧急
          </span>
        </div>
        <button
          onClick={() => navigate("/alarm")}
          className="text-xs text-[#E8531A] hover:underline cursor-pointer whitespace-nowrap"
        >
          全部告警 <i className="ri-arrow-right-line"></i>
        </button>
      </div>

      {/* Scrolling list */}
      <div className="overflow-hidden" style={{ height: 200 }}>
        <div
          className="transition-transform duration-500"
          style={{ transform: `translateY(-${activeIdx * 40}px)` }}
        >
          {[...alarms, ...alarms].map((alarm, i) => {
            const cfg = levelConfig[alarm.level as keyof typeof levelConfig];
            return (
              <div
                key={`${alarm.id}-${i}`}
                className={`flex items-center gap-3 px-4 py-2.5 border-b border-gray-50 cursor-pointer hover:bg-gray-50 transition-colors ${i === activeIdx ? "bg-orange-50/50" : ""}`}
                style={{ height: 40 }}
                onClick={() => navigate("/alarm")}
              >
                <div className={`w-1.5 h-1.5 rounded-full flex-shrink-0 ${cfg.dot} ${alarm.level === "danger" ? "animate-pulse" : ""}`}></div>
                <span className={`text-[10px] font-medium px-1.5 py-0.5 rounded ${cfg.bg} ${cfg.color} whitespace-nowrap`}>{cfg.label}</span>
                <span className="text-xs text-gray-700 flex-1 truncate">{alarm.msg}</span>
                <span className="text-[10px] text-gray-400 whitespace-nowrap">{alarm.time}</span>
              </div>
            );
          })}
        </div>
      </div>

      <div className="flex items-center justify-between px-4 py-2 bg-gray-50">
        <span className="text-[10px] text-gray-400">今日共 {alarms.length} 条告警</span>
        <div className="flex gap-1">
          {alarms.map((_, i) => (
            <button
              key={i}
              onClick={() => setActiveIdx(i)}
              className={`w-1 h-1 rounded-full transition-all cursor-pointer ${i === activeIdx % alarms.length ? "bg-[#E8531A] w-3" : "bg-gray-300"}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
